import classNames from 'classnames';

const Row = ({children, className, rowRef, ...props}) => (
    <div {...props} className={classNames('row', className)} ref={rowRef}>
        {children}
    </div>
);

export default Row;
